import { Injectable } from '@angular/core';
import { JcklaServicePkg } from './jcklaPkg.service';

@Injectable({
  providedIn: 'root',
})
export class JcklaService extends JcklaServicePkg {
  constructor() {
    super();
  }
}
